(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ocni-inspirations"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ocni-inspiration-guide')) return;
  class OCNIInspirationGuide extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.setup(); });
    }
    disconnectedCallback() { if (this.controller) this.controller.abort(); }
    setup() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.tabs = Array.from(this.querySelectorAll('[data-route]'));
      this.sheets = Array.from(this.querySelectorAll('[data-flavor-sheet]'));
      this.sheets.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name,'fr',{sensitivity:'base'}));
      this.sheets.forEach(sheet=>sheet.parentElement.appendChild(sheet));
      const picker=this.querySelector('.ocni-flavors');
      if(picker) Array.from(picker.querySelectorAll('[data-flavor]')).sort((a,b)=>a.textContent.trim().localeCompare(b.textContent.trim(),'fr',{sensitivity:'base'})).forEach(button=>picker.appendChild(button));

      this.querySelectorAll('[data-flavor]').forEach(button => {
        const hex=button.style.getPropertyValue('--ocni-flavor').trim();
        if (!/^#[0-9a-f]{6}$/i.test(hex)) return;
        const rgb=[1,3,5].map(i=>parseInt(hex.slice(i,i+2),16)/255);
        const luminance=rgb.map(v=>v<=0.04045?v/12.92:Math.pow((v+0.055)/1.055,2.4)).reduce((sum,v,i)=>sum+v*[0.2126,0.7152,0.0722][i],0);
        button.style.setProperty('--ocni-button-ink',1.05/(luminance+0.05)>=(luminance+0.05)/0.05?'#ffffff':'#000000');
      });

      this.bases = Array.from(this.querySelectorAll('[data-base-sheet]'));
      this.state = Object.assign({}, OCNIInspirationGuide.states.get(this.dataset.sectionId));
      const search=this.querySelector('[data-dish-search]');
      const clearSearch=this.querySelector('[data-clear-search]');
      if(search){
        search.value=this.state.query||'';
        clearSearch.hidden=!search.value;
        const updateSearch=()=>{this.state.query=search.value;clearSearch.hidden=!search.value;this.selectCategory(this.state.category||'all');};
        search.addEventListener('input',updateSearch,{signal});
        clearSearch.addEventListener('click',()=>{search.value='';updateSearch();search.focus();},{signal});
      }
      const dishFilter=this.querySelector('[data-dish-flavor]');
      if(dishFilter){
        if(!this.sheets.some(sheet=>sheet.dataset.flavorSheet===this.state.dishFlavor))this.state.dishFlavor='';
        dishFilter.replaceChildren();
        const all=document.createElement('option');all.value='';all.textContent='Tous les crayons';all.selected=!this.state.dishFlavor;dishFilter.append(all);
        this.sheets.forEach(sheet=>{const option=document.createElement('option');option.value=sheet.dataset.flavorSheet;option.textContent=sheet.dataset.name;option.selected=option.value===this.state.dishFlavor;dishFilter.append(option);});
        dishFilter.addEventListener('change',()=>{this.state.dishFlavor=dishFilter.value;this.selectCategory(this.state.category,true);},{signal});
      }

      this.querySelector('[data-routes]').hidden = false;
      this.querySelectorAll('[data-flavor-picker],[data-base-picker]').forEach(el => { el.hidden = false; });
      this.querySelectorAll('[data-view]').forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', this.dataset.sectionId + '-tab-' + panel.dataset.view);
      });
      this.selectFlavor(this.state.flavor || (this.sheets[0] && this.sheets[0].dataset.flavorSheet));
      this.selectBase(this.state.base || (this.bases[0] && this.bases[0].dataset.baseSheet));
      this.querySelectorAll('[data-category-choice]').forEach(button => {
        button.hidden = !this.sheets.some(sheet => Array.from(sheet.querySelectorAll('[data-idea]')).some(card => this.matchesCategory(card, button.dataset.categoryChoice)));
      });
      const firstCategory = this.querySelector('[data-category-choice]:not([hidden])');
      const savedCategory = Array.from(this.querySelectorAll('[data-category-choice]')).find(button => !button.hidden && button.dataset.categoryChoice === this.state.category);
      if (firstCategory) this.selectCategory(savedCategory ? savedCategory.dataset.categoryChoice : firstCategory.dataset.categoryChoice,false,true);
      else if (this.querySelector('[data-empty]')) this.querySelector('[data-empty]').hidden = false;
      this.querySelectorAll('[data-variant]').forEach(variant => {
        const name = variant.dataset.matchName.trim().toLocaleLowerCase('fr');
        const sheet = this.sheets.find(item => item.dataset.name.trim().toLocaleLowerCase('fr') === name);
        const button = variant.querySelector('[data-variant-link]');
        if (button) {
          button.hidden = !sheet;
          if (sheet) {
            button.dataset.openFlavor = sheet.dataset.flavorSheet;
            variant.style.setProperty('--ocni-flavor', sheet.dataset.accent);
          }
        }
      });
      this.showRoute(this.state.route || 'pencil');
      this.readHash();
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if(button.hasAttribute('data-load-more'))this.appendDishBatch(12,true);
        if(button.hasAttribute('data-back-categories')){
          const active=this.querySelector('[data-category-choice][aria-pressed="true"]')||this.querySelector('[data-category-choice]');
          if(active)active.focus({preventScroll:true});
          this.querySelector('[data-dish-categories]').scrollIntoView({block:'start',behavior:'auto'});
        }
        if (button.dataset.route) this.showRoute(button.dataset.route);
        if (button.dataset.flavor) this.selectFlavor(button.dataset.flavor, true);
        if (button.dataset.categoryChoice) this.selectCategory(button.dataset.categoryChoice, true);
        if (button.dataset.base) this.selectBase(button.dataset.base, true);
        if (button.dataset.openFlavor) {
          this.selectFlavor(button.dataset.openFlavor, true);
          this.showRoute('pencil');
          this.tabs[0].focus({preventScroll:true});
          this.querySelector('[data-routes]').scrollIntoView({block:'start',behavior:'auto'});
        }
      }, {signal});
      this.querySelector('[data-routes]').addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.showRoute(this.tabs[next].dataset.route);
        this.tabs[next].focus();
      }, {signal});
      window.addEventListener('hashchange', () => this.readHash(), {signal});
      if (this.dataset.editor === 'true') {
        document.addEventListener('shopify:block:select', event => {
          const id = event.detail && event.detail.blockId;
          const extra = Array.from(this.querySelectorAll("[data-extra-block]")).find(item => item.dataset.extraBlock === id);
          const flavor = this.sheets.find(sheet => sheet.dataset.flavorSheet === id) || (extra && extra.closest("[data-flavor-sheet]"));
          const base = this.bases.find(sheet => sheet.dataset.baseSheet === id);
          if (flavor) { this.selectFlavor(flavor.dataset.flavorSheet); this.showRoute('pencil'); flavor.scrollIntoView({block:'nearest'}); }
          if (base) { this.selectBase(id); this.showRoute('base'); base.scrollIntoView({block:'nearest'}); }
        }, {signal});
      }
    }
    save() { OCNIInspirationGuide.states.set(this.dataset.sectionId, Object.assign({}, this.state)); }
    announce(text) { this.querySelector('[data-status]').textContent = text; }
    showRoute(route) {
      if (!this.tabs.some(tab => tab.dataset.route === route)) route = 'pencil';
      this.tabs.forEach(tab => { const selected=tab.dataset.route===route; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex=selected?0:-1; });
      this.querySelectorAll('[data-view]').forEach(panel => { panel.hidden=panel.dataset.view!==route; });
      this.state.route=route; this.save();
    }
    selectFlavor(id, announce=false) {
      const selected=this.sheets.find(sheet=>sheet.dataset.flavorSheet===id)||this.sheets[0];
      if (!selected) return;
      this.sheets.forEach(sheet=>{sheet.hidden=sheet!==selected;});
      this.querySelectorAll('[data-flavor]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.flavor===selected.dataset.flavorSheet)));
      this.state.flavor=selected.dataset.flavorSheet; this.save();
      if (announce) this.announce('Idées pour le crayon '+selected.dataset.name);
    }
    selectBase(id, announce=false) {
      const selected=this.bases.find(sheet=>sheet.dataset.baseSheet===id)||this.bases[0];
      if (!selected) return;
      this.bases.forEach(sheet=>{sheet.hidden=sheet!==selected;});
      this.querySelectorAll('[data-base]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.base===selected.dataset.baseSheet)));
      this.state.base=selected.dataset.baseSheet; this.save();
      if (announce) this.announce(selected.querySelector('h2').textContent);
    }
    matchesCategory(card, category) {
      const label = card.dataset.diet || ''; 
      return category === 'all' || card.dataset.category === category || (category === 'viandes' && label === 'Viande') || (category === 'poissons' && label.startsWith('Poisson'));
    }
    searchWords(text) {
      return text.toLocaleLowerCase('fr').replace(/œ/g,'oe').normalize('NFD').replace(/[\u0300-\u036f]/g,'').split(/[^a-z0-9]+/).filter(Boolean).map(word=>word.length>3?word.replace(/[sx]$/,''):word);
    }
    matchesSearch(card) {
      const query=this.searchWords(this.state.query||'');
      const ingredients=card.querySelector('.ocni-ingredients');
      const title=card.querySelector('h4,h3');
      const fallback=card.querySelector('.ocni-idea-body');
      const words=this.searchWords((title?title.textContent:'')+' '+(ingredients?ingredients.textContent:fallback?fallback.textContent:''));
      return query.every(term=>words.some(word=>word===term||(term.length>=3&&word.startsWith(term))));
    }
    selectCategory(category, announce=false, preserveCount=false) {
      const results=this.querySelector('[data-dish-results]');
      if(!results)return;
      const previousCount=preserveCount&&this.state.category===category?this.state.dishVisible:12;
      results.replaceChildren();
      this.querySelectorAll('[data-category-choice]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.categoryChoice===category)));
      const groups=this.sheets.filter(sheet=>!this.state.dishFlavor||sheet.dataset.flavorSheet===this.state.dishFlavor).map(sheet=>({sheet,cards:Array.from(sheet.querySelectorAll('[data-idea]')).filter(card=>this.matchesCategory(card,category)&&this.matchesSearch(card))}));
      this.dishItems=[];
      // Alternate pencils so the first results offer a range of flavors.
      for(let index=0;groups.some(group=>group.cards[index]);index++){
        groups.forEach(group=>{if(group.cards[index])this.dishItems.push({sheet:group.sheet,card:group.cards[index]});});
      }
      this.state.category=category;this.state.dishVisible=0;
      const active=this.querySelector('[data-category-choice][aria-pressed="true"]');
      this.querySelector('[data-dish-heading]').textContent=category==='all'?'Des idées pour votre assiette':active?'Des idées : '+active.textContent.toLocaleLowerCase('fr'):'Quelques idées pour votre assiette';
      this.appendDishBatch(Number.isFinite(previousCount)&&previousCount>0?previousCount:12);
      if(announce)this.announce(this.dishItems.length+' idées disponibles');
    }
    appendDishBatch(amount=12, focusNew=false) {
      const results=this.querySelector('[data-dish-results]');
      if(!results||!this.dishItems)return;
      const start=results.children.length;
      const end=Math.min(start+amount,this.dishItems.length);
      let firstNew;
      this.dishItems.slice(start,end).forEach(({sheet,card})=>{
        const clone=card.cloneNode(true);clone.removeAttribute('data-idea');clone.dataset.resultFlavor=sheet.dataset.flavorSheet;
        clone.style.setProperty('--ocni-flavor',sheet.dataset.accent);
        const heading=clone.querySelector('h4');if(heading){const h3=document.createElement('h3');h3.textContent=heading.textContent;heading.replaceWith(h3);}
        const button=document.createElement('button');button.type='button';button.className='ocni-see cursor-interaction';button.dataset.openFlavor=sheet.dataset.flavorSheet;button.textContent='Voir les idées de ce crayon →';clone.append(button);
        results.append(clone);if(!firstNew)firstNew=clone;
      });
      const total=this.dishItems.length;
      this.querySelector('[data-empty]').hidden=total>0;
      this.querySelector('[data-dish-count]').textContent=end+' idée'+(end===1?'':'s')+' sur '+total;
      const more=this.querySelector('[data-load-more]');more.hidden=end>=total;
      const next=Math.min(12,total-end);more.textContent='Voir '+next+' idée'+(next===1?'':'s')+' de plus';
      this.state.dishVisible=end;this.save();
      if(focusNew&&firstNew){
        firstNew.querySelector('[data-open-flavor]').focus({preventScroll:true});
        firstNew.scrollIntoView({block:'start',behavior:'auto'});
      }
    }
    readHash() {
      if(this.dataset.editor==='true')return;
      let slug;try{slug=decodeURIComponent(window.location.hash.slice(1));}catch(e){return;}
      if(!slug.startsWith('crayon-'))return;
      const sheet=this.sheets.find(item=>'crayon-'+item.dataset.slug===slug);
      if(sheet){this.selectFlavor(sheet.dataset.flavorSheet);this.showRoute('pencil');}
    }
  }
  OCNIInspirationGuide.states=new Map();
  customElements.define('ocni-inspiration-guide',OCNIInspirationGuide);
})();

  } catch(e) { console.error(e); }
})();
})();
